import { Link } from "react-router-dom";
import { ChevronRight, CalendarDays } from "lucide-react";
import { Seo } from "../components/Seo";
import { CtaBand } from "../components/CtaBand";
import { POSTS, postPath } from "../data/posts";

export default function BlogIndex() {
  return (
    <div data-testid="blog-index-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-8">
      <Seo
        title="Security Blog Ontario | Guard, Patrol & Safety Guides"
        description="Ontario security insights: concierge security, fire watch rules, construction theft prevention, guard licensing, K9 units & loss prevention. 1st Nations Security."
        path="/security-blog"
      />
      <p className="text-xs font-semibold uppercase tracking-widest text-amber-500 mb-3">1st Nations Security — Security Blog</p>
      <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white font-heading mb-5">
        Ontario Security Insights & Guides
      </h1>
      <p className="text-base text-slate-300 leading-relaxed max-w-3xl mb-12">
        Plain-language answers to the questions Ontario businesses ask about security guards, mobile patrol, fire
        watch, construction site theft, loss prevention and security guard licensing — from a 100% Indigenous-owned
        Ontario security company.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {POSTS.map((p) => (
          <Link
            key={p.slug}
            to={postPath(p)}
            data-testid={`blog-card-${p.slug}`}
            className="group rounded-2xl border border-white/10 bg-slate-900/60 p-6 transition-all duration-200 hover:border-amber-500/40 hover:bg-slate-900"
          >
            <p className="text-xs font-semibold uppercase tracking-widest text-amber-500 mb-2">{p.category}</p>
            <h2 className="text-lg font-semibold text-white mb-2 group-hover:text-amber-300 transition-colors">{p.title}</h2>
            <p className="text-sm text-slate-400 leading-relaxed mb-4">{p.excerpt}</p>
            <span className="flex items-center justify-between text-xs text-slate-500">
              <span className="inline-flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" /> {p.date}</span>
              <span className="inline-flex items-center gap-1 text-amber-400 font-semibold">Read guide <ChevronRight className="h-3.5 w-3.5" /></span>
            </span>
          </Link>
        ))}
      </div>
      <CtaBand
        heading="Have a Security Question We Haven't Covered?"
        sub="Call our 24/7 dispatch at +1 807-770-0243 or email admin@1stnation-security.com — real answers from people who run guard operations across Ontario."
      />
    </div>
  );
}
